import React from "react";
import { Checkbox, styled, Box, Typography } from "@mui/material";
import { COLORS } from "../assets/theme";

interface CustomCheckboxProps {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  ariaLabel?: string;
}

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  color: COLORS.MainColor,
  "&.Mui-checked": {
    color: COLORS.MainColor,
    marginLeft: "1px",
  },
  "&:hover": {
    backgroundColor: "rgba(163, 148, 85, 0.08)",
  },
}));

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  checked,
  onChange,
  label,
  ariaLabel,
}) => (
  <Box display="flex" alignItems="center">
    <StyledCheckbox
      checked={checked}
      onChange={onChange}
      inputProps={{ "aria-label": ariaLabel }}
    />
    <Typography variant="body1">{label ?? ""}</Typography>
  </Box>
);

export default CustomCheckbox;
